import {ChangeEvent, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {parseUSPhoneNumber} from '~/common/utils';
import {DefaultWarning} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/DefaultWarning';
import {PhoneWarning} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/PhoneWarning';
import {Payload} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {selectIsSMSInvite} from '~/ViewInvitation/selectors/rsvp';
import {Checkbox} from '~library/atoms/Checkbox';
import {Typography} from '~library/atoms/Typography';

type RSVPModalVariantABContentProps = {
  phone: Pick<Payload, 'phone'>;
  smsOptIn: boolean;
  setSmsOptIn: (value: boolean) => void;
  preText: string;
};

export const OptinAndWarning = ({
  phone,
  smsOptIn,
  setSmsOptIn,
  preText,
}: RSVPModalVariantABContentProps) => {
  const isSMSInvite = useSelector(selectIsSMSInvite);
  const phoneIsValid = parseUSPhoneNumber(phone).is_valid;

  const onSmsOptInChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setSmsOptIn(e.target.checked),
    [setSmsOptIn]
  );

  return (
    <>
      {phoneIsValid && isSMSInvite && (
        <Checkbox
          id="sms-opt-in"
          data-qa-id="sms-opt-in-checkbox"
          onChange={onSmsOptInChange}
          checked={smsOptIn}
          labelClassName="sms-opt-in-checkbox"
          label={<Typography variant="paragraph3">Get text updates for this event</Typography>}
        />
      )}
      {phoneIsValid ? <PhoneWarning preText={preText} /> : <DefaultWarning />}
    </>
  );
};
